import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { BookingService } from '../../services/api/BookingService';
import { BookingRequest } from '../../models/api/BookingRequest';
import { SharedTherapistDetailService } from '../../services/shared-therapist-detail.service';
import { TherapistModel } from '../../models/api/TherapistModel';
import { Router } from '@angular/router';
import { TherapistDashboardService } from '../../services/api/TherapistDashboardService';
import { TherapistEventService } from '../../services/api/TherapistEventService';
import { TherapistEventDetailsModel } from '../../models/api/TherapistEventDetails';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-quick-create-booking',
  standalone: true,
  imports: [FormsModule, MatFormFieldModule, MatIconModule, MatInputModule, ReactiveFormsModule, MatButtonModule, MatProgressBarModule],
  templateUrl: './quick-create-booking.component.html',
  styleUrl: './quick-create-booking.component.scss'
})

export class QuickCreateBookingComponent implements OnInit {

  bookingForm!: FormGroup;
  // therapistDetail: TherapistModel = new TherapistModel;
  public therapistEventData: TherapistEventDetailsModel = new TherapistEventDetailsModel;
  public loading: boolean = true;
  public disableForm: boolean = false;

  constructor(private fb: FormBuilder,
    private bookingService: BookingService,
    private therapistDashboardService: TherapistDashboardService,
    private sharedTherapistDetailService: SharedTherapistDetailService,
    private therapistEventService: TherapistEventService,
    private router: Router,
    private snackbar: MatSnackBar,
    private authService: AuthService,
  ) { }

  ngOnInit(): void {

    this.therapistEventService.getActiveByTherapist().subscribe(data => {
      this.therapistEventData = data;

      if (this.therapistEventData.therapistId && this.therapistEventData.eventId) {
        this.bookingForm = this.fb.group({
          name: [''],
          location: [''],
          otherNotes: [''],
          eventID: [this.therapistEventData.eventId],
          requestedTherapistID: this.therapistEventData.therapistId,
        });
        this.loading = false;
      }
    })
  }

  addBookingAndStartMassage() {
    this.disableForm = true;
    const booking: BookingRequest = this.bookingForm.value;

    this.therapistDashboardService.bookingRequest(booking).subscribe({
      next: (response) => {

        this.bookingService.getBooking(response.reference!).subscribe(data => {
          this.therapistDashboardService.forceStartBooking(data.bookingID).subscribe(data => {
            this.router.navigate(['therapist-portal', 'dashboard']);
          })
        })
      },
      error: (err) => {

        if (err.errorCode === 0) {
          this.snackbar.open('Network error. Please check your internet connection and try again', 'Dismiss');
          this.disableForm = false;
        }
        else if (err.errorCode === 401) {
          this.snackbar.open('Your sesison has expired. Please log in and try again', 'Dismiss');
          this.logOutUser();
        }
        else if (err.errorCode === 403){
          this.snackbar.open('You are not authosied to create a booking.', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 404){
          this.snackbar.open('Booking not found, please try again', 'dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 400){
          this.snackbar.open('Invalid request, please check the booking and try again', 'dismiss');
          this.disableForm = false;
        }
        else if (err.errorCode >= 500){
          this.snackbar.open('Server error, please try again later', 'dismiss');
          this.disableForm = false;    
        }
      }
    })
  }

  addBooking() {
    this.disableForm = true;
    const booking: BookingRequest = this.bookingForm.value;

    this.bookingService.bookingRequest(booking).subscribe({
      next: (response) => {
        this.router.navigate(['therapist-portal', 'dashboard']);
      },
      error: (err) => {
        if (err.errorCode === 0) {
          this.snackbar.open('Network error. Please check your internet connection and try again', 'Dismiss');
          this.disableForm = false;
        }
        else if (err.errorCode === 401) {
          this.snackbar.open('Your sesison has expired. Please log in and try again', 'Dismiss');
          this.logOutUser();
        }
        else if (err.errorCode === 403){
          this.snackbar.open('You are not authorised to create a booking.', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 404){
          this.snackbar.open('Booking not found, please try again', 'dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 400){
          this.snackbar.open('Invalid request, please check the booking and try again', 'dismiss');
          this.disableForm = false;
        }
        else if (err.errorCode >= 500){
          this.snackbar.open('Server error, please try again later', 'dismiss');
          this.disableForm = false;      
        }
      }
    })
  }

  logOutUser() {
    this.router.navigate(['login']);
    this.authService.logout().subscribe({});
  }
}
